import { z } from "zod";
import { SyncMutationSchema, MAX_SYNC_BATCH_RECORDS } from "./sync";

export const JobNameSchema = z.enum([
  "sync.retry",
  "compass.price-reminders.check",
  "puzzle.grading.execute",
  "puzzle.grading.reconcile",
  "lightyear.calendar.outbound",
  "lightyear.calendar.inbound",
  "lightyear.calendar.outbound.reconcile",
  "steward.bill.reminder",
  "steward.bill.collect.electricity",
  "steward.bill.collect.electricity.room",
  "steward.bill.collect.water",
  "steward.bill.collect.water.room",
  "steward.subscription.renewal",
  "notification.deliver",
  "maintenance.request-guard.cleanup",
  "maintenance.sync-retention.cleanup",
  "jarvis.temporary-files.cleanup",
]);

export const PuzzleGradingTaskJobPayloadSchema = z.object({
  taskId: z.string().uuid(),
});

export const LightyearCalendarOutboundJobPayloadSchema = z.object({
  commandId: z.string().uuid(),
});

export const LightyearCalendarInboundJobPayloadSchema = z.object({
  connectionId: z.string().uuid(),
});

export const SyncRetryJobPayloadSchema = z.object({
  userId: z.string().uuid(),
  mutations: z.array(SyncMutationSchema).max(MAX_SYNC_BATCH_RECORDS),
  deviceId: z.string().trim().min(1).max(64),
});

export const StewardBillCollectionJobPayloadSchema = z.object({
  snapshotAt: z.string().datetime().optional(),
  afterTaskId: z.number().int().nonnegative().default(0),
});

export const StewardBillRoomCollectionJobPayloadSchema = z.object({
  taskId: z.number().int().positive(),
  roomId: z
    .string()
    .trim()
    .regex(/^[A-Za-z0-9-]{1,64}$/),
  snapshotAt: z.string().datetime(),
});

export const StewardSubscriptionRenewalJobPayloadSchema = z.object({
  snapshotAt: z.string().datetime().optional(),
  afterRecordId: z.number().int().nonnegative().default(0),
  maxRecordId: z.number().int().nonnegative().optional(),
});

export const NotificationDeliveryCompletionSchema = z.object({
  type: z.literal("steward.bill.reminder"),
  stateId: z.number().int().positive(),
  sequence: z.number().int().nonnegative(),
});

export const NotificationDeliveryJobPayloadSchema = z.object({
  message: z.record(z.string(), z.unknown()),
  completion: NotificationDeliveryCompletionSchema.optional(),
});

export const JobEnvelopeSchema = z.object({
  idempotencyKey: z.string().min(1).max(255),
  traceId: z.string().min(1).optional(),
  payload: z.record(z.string(), z.unknown()),
});

export type JobName = z.infer<typeof JobNameSchema>;
export type JobEnvelope = z.infer<typeof JobEnvelopeSchema>;
export type NotificationDeliveryCompletion = z.infer<
  typeof NotificationDeliveryCompletionSchema
>;
